import { HttpErrorModel, LoggerService, tryNormalizeHttpError } from '@spartacus/core';

export function getHttpErrorMessage(error: any, logger: LoggerService): string {
  const httpError = tryNormalizeHttpError(error, logger);
  if (httpError instanceof HttpErrorModel) {
    const detail = httpError.details && httpError.details.length > 0 ? httpError.details[0].message : '';
    return detail || httpError.message || 'An unknown error occurred';
  }
  return 'An unknown error occurred';
}
